// extracted by mini-css-extract-plugin
export var standaloneTable = "_25-0";
export var standaloneTableWithBodyFill = "_25-1";
export var withExtraHeader = "_25-2";